import axios from 'axios';
import { resultInfo } from 'Components/helpers';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseApi from 'shared/api';

export function useGetFavoriteFolderList({
   token,
   apiKey,
   onError,
   onSuccess,
}: {
   token: string;
   apiKey: string;
   onError?: () => void;
   onSuccess?: () => void;
}) {
   const { t } = useTranslation('global');
   const [foldersList, setFoldersList] = useState<FavFolder[]>([]);

   useEffect(() => {
      getFoldersList();
   }, []);

   const getFoldersList = async () => {
      try {
         const response = await axios.get<Array<FavFolder>>(BaseApi + '/folder/list', {
            headers: {
               'Content-Type': 'application/json',
               key: apiKey,
               token: token,
            },
         });

         if (response.status === 200) {
            setFoldersList(response.data);
         } else {
            if ('message' in response.data)
               resultInfo('error', response.data.message, t('jobseekerManageAlert.close'));
         }
      } catch (error) {
         console.error('Cannot get folders list', error);
      }
   };

   return { foldersList, getFoldersList };
}

export type FavFolder = {
   id: number;
   user_id: number;
   name: string;
   slug: string;
   created_at: string;
   updated_at: string;
};
